import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home';
import Coaching from './components/Coaching';
import Contact from './components/Contact';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2196F3',
    },
    secondary: {
      main: '#FFFFFF',
    },
    background: {
      default: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/youtube" element={<YoutubeRedirect />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

const YoutubeRedirect = () => {
  React.useEffect(() => {
    window.location.href = 'https://www.youtube.com/@therealraymondjones';
  }, []);
  
  return <div>Redirecting to YouTube...</div>;
};

export default App;
